import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import FooterFile from "../../footer/FooterFile";

class Privacy extends Component<RouteComponentProps> {
    constructor(props: RouteComponentProps) {
        super(props);
    }

    render() {
        return <FooterFile FileName="Privacy" />;
    }
}

export default withRouter(Privacy);
